// extracted by mini-css-extract-plugin
module.exports = {"card":"card__1+8IS"};